
import { Link } from 'react-router-dom';

export default function Confidentialite() {
  return (
    <section className="legal-content container-narrow">
      <span className="eyebrow">Informations</span>

      <h1>Politique de confidentialité</h1>

      <p>
        Vague de Mots accorde une attention particulière à la
        confidentialité des informations que vous lui confiez,
        notamment dans le cadre de vos projets d'écriture.
      </p>

      <h2>Responsable du traitement</h2>

      <p>
        Les données transmises par le formulaire de contact sont
        traitées par Vague de Mots, dans le cadre de son activité
        de lecture et de correction de textes.
      </p>

      <p>
        Pour toute question relative à vos données personnelles,
        vous pouvez écrire à :
        {' '}
        <a href="mailto:contact@vaguedemots.fr">
          contact@vaguedemots.fr
        </a>.
      </p>

      <h2>Formulaire de contact</h2>

      <p>
        Lorsque vous utilisez le formulaire de contact, les
        informations suivantes sont recueillies :
        votre nom et prénom, votre adresse e-mail, la prestation
        concernée et le contenu de votre message.
      </p>

      <p>
        Ces informations sont utilisées uniquement pour prendre
        connaissance de votre demande, vous répondre et échanger
        avec vous au sujet de votre projet.
      </p>

      <p>
        Le traitement de ces informations repose sur les démarches
        effectuées à votre demande avant une éventuelle prestation,
        ou sur l'intérêt légitime de répondre à vos demandes
        de renseignements.
      </p>

      <h2>Transmission et destinataires</h2>

      <p>
        Les messages envoyés depuis le formulaire sont transmis
        de manière sécurisée au serveur de Vague de Mots, puis
        acheminés par courrier électronique au moyen du service
        Brevo.
      </p>

      <p>
        Les informations sont destinées à Vague de Mots et ne
        sont pas utilisées à des fins de prospection commerciale
        sans base légale appropriée.
      </p>


      <p>
        L'infogérance et la maintenance technique du site
        sont assurées par NOVEANCE, qui peut être amenée
        à accéder à certaines données techniques dans
        le cadre de ses interventions autorisées.
      </p>


      <h2>Conservation des données</h2>

      <p>
        Les messages et les informations associées sont conservés
        pendant la durée nécessaire au traitement des demandes,
        puis supprimés lorsqu'ils ne sont plus nécessaires,
        sous réserve des obligations légales applicables.
      </p>

      <h2>Vos droits</h2>

      <p>
        Conformément à la réglementation applicable en matière
        de protection des données personnelles, vous disposez,
        selon votre situation, de droits d'accès, de rectification,
        d'effacement, d'opposition et de limitation du traitement.
      </p>

      <p>
        Vous pouvez exercer ces droits en écrivant à
        {' '}
        <a href="mailto:contact@vaguedemots.fr">
          contact@vaguedemots.fr
        </a>.
        Vous pouvez également adresser une réclamation à la CNIL.
      </p>


<h2>Cookies et mesure d'audience</h2>

<p>
  Le site Vague de Mots utilise Google Analytics 4,
  un service de mesure d'audience fourni par Google,
  afin de mieux comprendre sa fréquentation et
  d'améliorer ses contenus et ses prestations.
</p>

<p>
  Sous réserve de votre consentement, cet outil permet
  notamment de mesurer les pages consultées, les
  interactions avec le site, les sources de trafic
  et certaines informations techniques relatives
  à votre navigateur et à votre appareil.
</p>

<p>
  Google Analytics n'est activé qu'après votre accord.
  Vous pouvez accepter ou refuser les cookies
  statistiques depuis le bandeau de consentement.
  Votre refus n'empêche pas l'utilisation du site.
</p>

<p>
  Vous pouvez retirer votre consentement à tout
  moment grâce au bouton « Gérer les cookies »
  disponible sur le site.
</p>

<p>
  En cas de retrait du consentement, les nouvelles
  mesures sont désactivées et les cookies Analytics
  accessibles depuis le site sont supprimés,
  dans les limites techniques du navigateur.
</p>

<h2>Durée de conservation des données Analytics</h2>

<p>
  La durée de conservation des données liées aux
  événements et aux utilisateurs dans Google Analytics
  dépend des paramètres de conservation définis
  dans la propriété Google Analytics 4.
</p>

<p>
  Les informations relatives à ces durées et aux
  modalités de traitement pourront être obtenues
  en écrivant à contact@vaguedemots.fr.
</p>

<h2>Destinataires des données de mesure d'audience</h2>

<p>
  Les données de mesure d'audience sont traitées
  au moyen des services de Google.
  Certains traitements peuvent impliquer des
  transferts de données en dehors de l'Espace
  économique européen, dans le cadre des garanties
  applicables à ces transferts.
</p>


      <p>
        À ce stade, le site n'intègre pas d'outil de mesure
        d'audience ni de cookie publicitaire.
      </p>

      <h2>Nous contacter</h2>

      <p>
        Pour toute question concernant cette politique,
        vous pouvez utiliser la
        {' '}
        <Link to="/contact">page de contact</Link>.
      </p>
    </section>
  );
}
